var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Preferences } from '@capacitor/preferences';
const getValueFromLocalStorage = (key) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { value } = yield Preferences.get({ key });
        return value ? JSON.parse(value) : null;
    }
    catch (error) {
        console.error(`Error getting ${key}:`, error);
        return null;
    }
});
const getMultipleValueFromLocalStorage = (keys) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const result = {};
        for (const key of keys) {
            const { value } = yield Preferences.get({ key });
            result[key] = value ? JSON.parse(value) : null;
        }
        return result;
    }
    catch (error) {
        console.error(`Error getting multiple keys:`, error);
        return {};
    }
});
const saveValueInLocalStorage = (key, value) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const valueToSave = JSON.stringify(value);
        yield Preferences.set({ key, value: valueToSave });
        // // console.log(`Saved ${key} to Preferences`);
    }
    catch (error) {
        console.error(`Error saving ${key}:`, error);
        throw error;
    }
});
const clearLocalStorage = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield Preferences.clear();
        // // console.log('Cleared Preferences');
    }
    catch (error) {
        console.error('Error clearing Preferences:', error);
        throw error;
    }
});
const removeFromLocalStorage = (key) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield Preferences.remove({ key });
        // // console.log(`Removed ${key} from Preferences`);
    }
    catch (error) {
        console.error(`Error removing ${key}:`, error);
        throw error;
    }
});
const getValueFromSessionStorage = (key) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { value } = yield Preferences.get({ key: `__SESSION_${key}` });
        return value ? JSON.parse(value) : null;
    }
    catch (error) {
        console.error(`Error getting session ${key}:`, error);
        return null;
    }
});
const saveValueInSessionStorage = (key, value) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const valueToSave = JSON.stringify(value);
        yield Preferences.set({ key: `__SESSION_${key}`, value: valueToSave });
        // // console.log(`Saved session ${key} to Preferences`);
    }
    catch (error) {
        console.error(`Error saving session ${key}:`, error);
        throw error;
    }
});
const removeFromSessionStorage = (key) => __awaiter(void 0, void 0, void 0, function* () {
    //  try {
    //    await Preferences.remove({ key: `__SESSION_${key}` });
    //    // // console.log(`Removed session ${key} from Preferences`);
    //  } catch (error) {
    //    console.error(`Error removing session ${key}:`, error);
    //    throw error;
    //  }
});
const clearSessionStorage = () => __awaiter(void 0, void 0, void 0, function* () {
    //  try {
    // Rimuovi solo le chiavi di sessione note (es. __SESSION___MK)
    //    const sessionKeys = [LocalStorageKeyEnum.__MK];
    //    for (const key of sessionKeys) {
    //      await Preferences.remove({ key: `__SESSION_${key}` });
    //      // // console.log(`Removed session key __SESSION_${key}`);
    //    }
    //  } catch (error) {
    //    console.error('Error clearing session Preferences:', error);
    //    throw error;
    //  }
});
const LocalStorageUtils = {
    getValueFromLocalStorage,
    saveValueInLocalStorage,
    getMultipleValueFromLocalStorage,
    clearLocalStorage,
    removeFromLocalStorage,
    getValueFromSessionStorage,
    saveValueInSessionStorage,
    clearSessionStorage,
    removeFromSessionStorage,
};
export default LocalStorageUtils;
